import styles from "./index.module.scss";

type SourceImgProps = {
  src: string;
  alt?: string;
}

const SourceImg = (props: SourceImgProps) => {
  const {
    src,
    alt,
  } = props;

  return (
    <div
      className={styles["source_img"]}
    >
      <img 
        src={src}
        alt={alt} 
      />
    </div>
  )
}

export default SourceImg;